/**
 * Registry der Hilfethemen (PV-037). Reihenfolge = Reihenfolge auf der Hilfeseite (A1).
 *
 * Aufnahmeregel (anforderung.md): Ein Thema kommt nur hierher, wenn es JEDEN Nutzer betrifft und
 * entweder aus der Anwendung ableitbar ist oder sich seltener als monatlich ändert.
 */
import type { HilfeThema, HilfeThemaId } from './hilfe-typen.js';
import { ThemaBefunde } from './thema-befunde.js';
import { ThemaDatenstand } from './thema-datenstand.js';
import { ThemaMcp } from './thema-mcp.js';
import { ThemaNews } from './thema-news.js';
import { ThemaPhasen } from './thema-phasen.js';
import { ThemaRolle } from './thema-rolle.js';

const IMMER = (): boolean => true;

export const HILFE_THEMEN: readonly HilfeThema[] = [
  {
    id: 'news',
    anker: 'news',
    titelKey: 'hilfe.news.titel',
    Komponente: ThemaNews,
    sichtbar: IMMER,
  },
  {
    id: 'rolle',
    anker: 'rolle',
    titelKey: 'hilfe.rolle.titel',
    Komponente: ThemaRolle,
    sichtbar: IMMER,
  },
  {
    id: 'datenstand',
    anker: 'datenstand',
    titelKey: 'hilfe.datenstand.titel',
    Komponente: ThemaDatenstand,
    sichtbar: IMMER,
  },
  {
    id: 'phasen',
    anker: 'phasen',
    titelKey: 'hilfe.phasen.titel',
    Komponente: ThemaPhasen,
    sichtbar: IMMER,
  },
  {
    id: 'befunde',
    anker: 'befunde',
    titelKey: 'hilfe.befunde.titel',
    Komponente: ThemaBefunde,
    sichtbar: (flags) => flags.befunde === true,
  },
  {
    id: 'mcp',
    anker: 'mcp',
    titelKey: 'hilfe.mcp.titel',
    Komponente: ThemaMcp,
    sichtbar: (flags) => flags.mcp_server === true,
  },
];

export function hilfeThema(id: HilfeThemaId): HilfeThema {
  const thema = HILFE_THEMEN.find((t) => t.id === id);
  if (!thema) throw new Error(`hilfe_thema_unbekannt:${id}`);
  return thema;
}
